import { useCallback } from "react";
import { sample } from "lodash";

function useTicketGenerator({ verbs, nouns, adjectives, reasons }) {
	return useCallback(() => {
		if (
			!verbs ||
			!verbs.length ||
			!nouns ||
			!nouns.length ||
			!adjectives ||
			!adjectives.length ||
			!reasons ||
			!reasons.length
		) {
			return "// TODO: Add words below";
		}

		return [
			sample(verbs),
			sample(nouns),
			"for",
			sample(adjectives),
			sample(reasons) + "."
		].join(" ");
	}, [verbs, nouns, adjectives, reasons]);
}

export default useTicketGenerator;
